import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import ProviderManager from '../../../provider/providerManager'

export const getCustomerServicesAvailable = createAsyncThunk('subscribersList/getCustomerServicesAvailable', async (thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('getCustomerActiveCellularList', []);
      return result;
    } catch (error) {
      return { Body: { userMobileNumbers: [], error: true } };
    }
});  

const subscribersListSlice = createSlice({
    name: 'subscribersList',
    initialState: {
        subscribers: [],
        fatalError: null
    },
    reducers: {

    },
    extraReducers: {
        [getCustomerServicesAvailable.fulfilled]: (state, action) => {
            return {...state, subscribers: action.payload.Body ? action.payload.Body : [], fatalError:  action.payload.Body.error ? action.payload.Body.error : false }
        },
    }
})

export const { } = subscribersListSlice.actions;

export default subscribersListSlice.reducer;